<template>
  <div>
    <h2 class="header-title">值班记录</h2>
    <Divider/>
    <div class="formDv">
      <Form :model="dutyForm" ref="dutyFormRefs" :rules="dutyRules" :label-width="120">
        <Row>
          <Col :span="8">
            <FormItem label="值班开始时间" prop="startTime">
              <DatePicker transfer v-model="dutyForm.startTime" type="datetime" placeholder="选择日期时间"/>
            </FormItem>
          </Col>
          <Col :span="8">
            <FormItem label="值班结束时间" prop="endTime">
              <DatePicker transfer v-model="dutyForm.endTime" type="datetime" placeholder="选择日期时间"/>
            </FormItem>
          </Col>
          <Col :span="8">
            <FormItem label="值班类型" prop="dutyType">
              <Select transfer v-model="dutyForm.dutyType" placeholder="请选择值班类型">
                <Option v-for="(item,index) in DutyTypeList" :key="index" :value="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="值班人员" prop="dutyPersonnel">
              <Input v-model="dutyForm.dutyPersonnel" placeholder="请输入值班人员"/>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="值班领导" prop="shiftLeader">
              <Input v-model="dutyForm.shiftLeader" placeholder="请输入值班领导"/>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="值班情况" prop="dutySituation">
          <Input type="textarea" :rows="4" v-model="dutyForm.dutySituation" placeholder="请输入值班情况"/>
        </FormItem>
        <FormItem label="值班办结情况" prop="dealtSituation">
          <Input type="textarea" :rows="4" v-model="dutyForm.dealtSituation" placeholder="请输入值班办结情况"/>
        </FormItem>
        <FormItem label="值班待办情况" prop="completionSituation">
          <Input type="textarea" :rows="4" v-model="dutyForm.completionSituation" placeholder="请输入值班待办情况"/>
        </FormItem>
        <FormItem>
          <Row>
            <Col :span="2" offset="8">
              <Button v-if="$route.query.recordId" type="primary" @click="editWatchRecord()"
                      :loading="editWatchRecordLoading">修改
              </Button>
              <Button v-else type="primary" @click="createNewWatchRecord()" :loading="createNewWatchRecordLoading">提交
              </Button>
            </Col>
            <Col :span="2">
              <Button @click="handleReset">重置</Button>
            </Col>
            <Col :span="2">
              <Button @click="goHistoryRecord()">历史值班记录</Button>
            </Col>
          </Row>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
export default {
  name: "WatchRecord",
  data() {
    return {
      createNewWatchRecordLoading: false,
      editWatchRecordLoading: false,
      dutyForm: {
        startTime: '', // 值班开始时间
        endTime: '', // 值班结束时间
        dutyType: '',// 值班类型
        dutyPersonnel: '',// 值班人员
        dutySituation: '',// 值班情况
        dealtSituation: '', // 值班办结情况
        shiftLeader: '',// 值班领导
        completionSituation: '' // 值班待办情况
      },
      dutyRules: {
        startTime: [
          { required: true, message: '请选择值班开始时间', trigger: 'change', type: 'date' }
        ],
        endTime: [
          { required: true, message: '请选择值班结束时间', trigger: 'change', type: 'date' }
        ],
        dutyType: [
          { required: true, message: '请选择值班类型', trigger: 'change' }
        ],
        dutyPersonnel: [
          { required: true, message: '请输入值班人员', trigger: 'blur' }
        ],
        dutySituation: [
          { required: true, message: '请输入值班情况', trigger: 'blur' }
        ],
        dealtSituation: [
          { required: true, message: '请输入值班办结情况', trigger: 'blur' }
        ],
        shiftLeader: [
          { required: true, message: '请输入值班领导', trigger: 'blur' }
        ],
        completionSituation: [
          { required: true, message: '请输入值班待办情况', trigger: 'blur' }
        ]
      },
      DutyTypeList: [] // 值班类型列表
    }
  },
  mounted() {
    this.getDutyType()
    let recordId = this.$route.query.recordId
    console.log(recordId)
    if (recordId) {
      this.getWatchRecordById(recordId)
    }
  },
  methods: {
    // 获取值班类型
    getDutyType() {
      this.$http.get('/api/dateTypes').then(res => {
        if (res.status === 200) {
          this.DutyTypeList = res.data.data
        }
        // console.log(res)
      })
    },
    // 创建新的值班记录
    createNewWatchRecord() {
      this.$refs.dutyFormRefs.validate((valid) => {
        if (valid) {
          this.createNewWatchRecordLoading = true
          this.$http.post('/api/dutyRecordss', this.dutyForm).then(res => {
            console.log(res)
            if (res.status === 201) {
              this.$Message.success('提交成功')
              this.createNewWatchRecordLoading = false
              this.handleReset()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改值班记录
    editWatchRecord() {
      this.$refs.dutyFormRefs.validate((valid) => {
        if (valid) {
          this.createNewWatchRecordLoading = true
          let requestData = {
            ...this.dutyForm,
            id: this.$route.query.recordId
          }
          this.$http.put('/api/dutyRecordss', requestData).then(res => {
            console.log(res)
            if (res.status === 200) {
              this.$Message.success('修改成功')
              this.editWatchRecordLoading = false
              this.handleReset()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 根据ID获取值班记录
    getWatchRecordById(id) {
      this.$http.get(`/api/dutyRecordss/${ id }`).then(res => {
        this.dutyForm = res.data
        this.dutyForm.dutyType = parseInt(res.data.dutyType)
      })
    },
    // 清除表单
    handleReset() {
      console.log(0)
      this.$refs.dutyFormRefs.resetFields()
      console.log(1)
    },
    // 历史值班记录
    goHistoryRecord() {
      this.$router.push({ name: 'historyRecord' })
    }
  }
}
</script>

<style scoped lang="less">
@import "css/WatchRecord.less";
</style>
